import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';

class PurchasePaymentComponent extends Component {

    constructor(){
        super();
        this.state = {
            method: 5, //1:efectivo | 2:transferencia | 3:mercadopago
            promo_code: "",
            // Gift card a USAR (FR-030). Excluyente con el cupón (FR-031): `promoTyped` /
            // `giftCardTyped` siguen lo tipeado en vivo para deshabilitar el otro campo, mientras
            // que `promo_code` / `gift_card_code` se emiten recién al salir del campo (recalcular
            // el precio en cada tecla pegaría al backend por nada).
            gift_card_code: "",
            promoTyped: false,
            giftCardTyped: false,
            // F1 del arqueo: cuando se cobra con tarjeta hay que saber POR CUÁL de los dos
            // lectores entró, o el cierre de lote de cada aparato no se puede conciliar.
            posDevices: [],
            posDeviceId: ""
        }
    }

    componentDidMount() {
        this.loadPosDevices();
        if (!this.props.isPurchaseChange)
            {
                const promoCode = document.getElementById('promo_code');
                promoCode.addEventListener('focusout', (event) => {
                this.setState({promo_code: promoCode.value})
                this.emit({ promo_code: promoCode.value });
            });
                const giftCardCode = document.getElementById('gift_card_code');
                giftCardCode.addEventListener('focusout', (event) => {
                this.setState({gift_card_code: giftCardCode.value})
                this.emit({ gift_card_code: giftCardCode.value });
            });
        }        
    }

    loadPosDevices = () => {
        const config = process.env;
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'posDevices', {
            headers: { 'access-token': localStorage.getItem('token') },
        })
            .then((r) => r.json())
            .then((data) => {
                if (data && data.error === 0 && Array.isArray(data.data) && data.data.length > 0) {
                    // Preseleccionado el de la tienda, que es donde se cobra la mayoría; el
                    // selector queda visible para cambiarlo cuando se cobra en el otro.
                    this.setState({ posDevices: data.data, posDeviceId: String(data.data[0].id) });
                    this.emit({ posDeviceId: String(data.data[0].id) });
                }
            })
            .catch(() => {});
    }

    // Un solo lugar que arma el payload: el padre lee `method`, `promo_code`, `gift_card_code`
    // y `posDeviceId`. Todo emit pasa por acá: si uno armara el objeto a mano, un clic en el
    // medio de pago borraría la gift card del estado del padre.
    emit = (overrides = {}) => {
        this.props.onChangeData({
            method: this.state.method,
            promo_code: this.state.promo_code,
            gift_card_code: this.state.gift_card_code,
            posDeviceId: this.state.posDeviceId,
            ...overrides,
        });
    }

    onChangePosDevice = (event) => {
        const posDeviceId = event.target.value;
        this.setState({ posDeviceId });
        this.emit({ posDeviceId });
    }

    onChangeInput = (input) => {
        var data = {};
        data["method"] = this.state.method;

        var id = input.target.id;
        if (id == "efectivo") {
            document.getElementById("transferencia").checked = false;
            document.getElementById("mercadopago").checked = false;
            document.getElementById("mercadolibre").checked = false;
            document.getElementById("pos").checked = false;
            data["method"] = 1;
            this.setState({method: 1})
        } else if (id == "transferencia") {
            document.getElementById("efectivo").checked = false;
            document.getElementById("mercadopago").checked = false;
            document.getElementById("mercadolibre").checked = false;
            document.getElementById("pos").checked = false;
            data["method"] = 2;
            this.setState({method: 2})
        } else if (id == "mercadopago") {
            document.getElementById("efectivo").checked = false;
            document.getElementById("transferencia").checked = false;
            document.getElementById("mercadolibre").checked = false;
            document.getElementById("pos").checked = false;
            data["method"] = 3;
            this.setState({method: 3})
        } else if (id == "mercadolibre") {
            document.getElementById("efectivo").checked = false;
            document.getElementById("transferencia").checked = false;
            document.getElementById("mercadopago").checked = false;
            document.getElementById("pos").checked = false;
            data["method"] = 4;
            this.setState({method: 4})
        } else if (id == "pos") {
            document.getElementById("efectivo").checked = false;
            document.getElementById("transferencia").checked = false;
            document.getElementById("mercadopago").checked = false;
            document.getElementById("mercadolibre").checked = false;
            data["method"] = 5;
            this.setState({method: 5})
        }
        this.emit({ method: data["method"] });
    }

    render() {
        return (
            <div className="col-lg-12">
                <div className="card card-small mb-4">
                    <div className="card-header border-bottom">
                        <span>Medio de pago</span>
                    </div>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item p-3">
                            <div class="custom-control custom-radio mb-1">
                                <input type="radio" id="efectivo" name="efectivo" class="custom-control-input" onClick={(e) => this.onChangeInput(e)}/>
                                <label class="custom-control-label" for="efectivo">Efectivo</label>
                            </div>
                            <div class="custom-control custom-radio mb-1">
                                <input type="radio" id="transferencia" name="transferencia" class="custom-control-input" onClick={(e) => this.onChangeInput(e)}/>
                                <label class="custom-control-label" for="transferencia">Transferencia</label>
                            </div>
                            <div class="custom-control custom-radio mb-1">
                                <input type="radio" id="mercadopago" name="mercadopago" class="custom-control-input" onClick={(e) => this.onChangeInput(e)}/>
                                <label class="custom-control-label" for="mercadopago">Mercado Pago</label>
                            </div>                           
                            <div class="custom-control custom-radio mb-1">
                                <input type="radio" id="mercadolibre" name="mercadolibre" class="custom-control-input" onClick={(e) => this.onChangeInput(e)}/>
                                <label class="custom-control-label" for="mercadolibre">Mercado Libre</label>
                            </div>
                            <div class="custom-control custom-radio mb-1">
                                <input type="radio" id="pos" name="pos" class="custom-control-input" onClick={(e) => this.onChangeInput(e)} defaultChecked="true"/>
                                <label class="custom-control-label" for="pos">POS</label>
                            </div>
                            {this.state.method === 5 && this.state.posDevices.length > 1 && (
                                <div className="form-group mt-2">
                                    <label htmlFor="pos-device">¿Con qué POS se cobró?</label>
                                    <select
                                        id="pos-device"
                                        className="form-control"
                                        value={this.state.posDeviceId}
                                        onChange={this.onChangePosDevice}
                                    >
                                        {this.state.posDevices.map((device) => (
                                            <option key={device.id} value={device.id}>{device.name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <br/>
                            <div className="row">                                
                                <div className="form-group col-md-4">
                                    {!this.props.isPurchaseChange ? 
                                        <div>
                                            <label>Promo code</label>
                                            <input type="text" className="form-control" id="promo_code" placeholder="Promo code"
                                                disabled={this.state.giftCardTyped}
                                                title={this.state.giftCardTyped ? 'No se combina con una gift card' : undefined}
                                                onChange={(e) => this.setState({ promoTyped: e.target.value.trim() !== '' })}/>
                                        </div>
                                        : ""
                                    }
                                </div>
                                <div className="form-group col-md-4">
                                    {!this.props.isPurchaseChange ? 
                                        <div>
                                            <label htmlFor="gift_card_code">Gift card</label>
                                            <input type="text" className="form-control" id="gift_card_code" placeholder="XXXX-XXXX-XX"
                                                autoComplete="off"
                                                disabled={this.state.promoTyped}
                                                title={this.state.promoTyped ? 'No se combina con un cupón' : undefined}
                                                onChange={(e) => this.setState({ giftCardTyped: e.target.value.trim() !== '' })}/>
                                        </div>
                                        : ""
                                    }
                                </div>
                                <div className="form-group col-md-4" style={{textAlign: 'right'}}>
                                    <label>SubTotal</label>
                                    <div style={{marginTop: '13px'}}>
                                        <strong>$ <span id="total_price_discount">{convertToMoney(0)}</span> <del><span style={{fontWeight: '300', fontSize: '12px', marginLeft: '5px'}} id="total_price"></span></del></strong>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default PurchasePaymentComponent;